@if (backNavigationService.canNavigateBack()) {
  <div
    class="flex flex-row title-bar-command"
    (click)="backNavigationService.navigateBack()"
  >
    <span class="pt-3 pb-3 ml-3 mr-3">
      <i class="fa-regular fa-arrow-left"></i>
    </span>
  </div>
}
@if (isMobileScreen$ | async) {
  <div
    class="flex flex-row items-center justify-center title-bar-command relative"
    (click)="maximizeSideMenu()"
  >
    @if (mainMenuBadges$ | async; as badge) {
      <span class="soft-badge">{{ badge }}</span>
    }
    <span class="pt-3 pb-3 ml-3 mr-3">
      <i class="fa-regular fa-bars"></i>
    </span>
  </div>
}

<div class="flex flex-col items-center justify-center ml-2.5 center-v h-12 truncate">
  <h4
    id="framework-application-titlebar-title"
    class="program-title font-semibold truncate"
  >
    {{ title() | translate }}
  </h4>
  @if (subtitle(); as subtitle) {
    <h6 id="framework-application-titlebar-subtitle" class="text-sm opacity-70 truncate">
      {{ subtitle | translate | interpolate: subtitleParams() }}
    </h6>
  }
</div>

<div class="title-bar-branding"></div>

@if (!!showUsername() || !!dateTimeFormat()) {
  <div class="flex items-center justify-end text-right">
    <div class="flex flex-col">
      @if (showUsername() && (username() | isDefinedNotEmpty)) {
        <div
          class="min-w-[150px] text-sm text-primary-contrast font-semibold whitespace-nowrap text-right"
        >
          {{ username() }}
        </div>
      }

      @if (dateTimeFormat(); as dateTimeFormat) {
        <div
          class="flex items-end justify-end text-right whitespace-nowrap text-sm text-primary-contrast opacity-60"
        >
          {{ currentDateTime() | date: dateTimeFormat }}
        </div>
      }
    </div>
  </div>
}

<div class="flex flex-row auto-width title-bar-commands ml-3">
  @for (command of leftCommands$ | async; track command) {
    <div class="flex flex-col items-center title-bar-command pt-3 pb-3">
      <soft-icon
        [name]="command.icon"
        *ngVar="command.canExecute ? (command.canExecute | async) : true as canExecute"
        (click)="
          onClick(
            canExecute,
            command.routerLink,
            command.execute,
            command.routerLinkParams
          )
        "
      >
      </soft-icon>
      <span class="title-bar-command-name">{{ command.name | translate }}</span>
    </div>
  }
</div>

<div
  class="flex flex-row auto-width title-bar-commands title-bar-commands-right flex-nowrap"
>
  @for (command of rightCommands$ | async; track command) {
    <div class="title-bar-command">
      @if (command?.badge | async; as badge) {
        <span class="soft-badge">{{ badge }}</span>
      }
      <span
        class="flex flex-col items-center justify-center px-3 relative h-full w-full"
        [ngClass]="command.class"
        *ngVar="command.canExecute ? (command.canExecute | async) : true as canExecute"
        (click)="
          onClick(
            canExecute,
            command.routerLink,
            command.execute,
            command.routerLinkParams
          )
        "
      >
        @if (command?.src) {
          <img
            [attr.src]="command.src"
            class="absolute top-1 title-bar-image"
            alt="image"
          />
        }
        <soft-icon class="absolute top-2" [name]="command.icon"></soft-icon>
        <span class="title-bar-command-name absolute bottom-2">{{
          command.name | translate
        }}</span>
      </span>
    </div>
  }
  <soft-menu-outlet name="title-bar-right"></soft-menu-outlet>
</div>

@if (
  (isMobileScreen$ | async) &&
  ((hasSideActions$ | async) || (hasActionMenuItems$ | async) || hasActionMenuItems())
) {
  <div class="action-menu-controls h-full">
    <div class="title-bar-command" (click)="maximizeActionMenu()">
      <span class="flex flex-col ml-3 mr-3 items-center">
        @if (actionMenuBadges$ | async; as badge) {
          <span class="soft-badge">{{ badge }}</span>
        }
        <i class="fa-regular fa-ellipsis-vertical actions-icon"></i>
        <span class="title-bar-command-name">{{ '#SHELL.ACTIONS' | translate }}</span>
      </span>
    </div>
  </div>
}
